import { PUBLIC_STRIPE_API_KEY } from "$env/static/public"
import { loadStripe } from "@stripe/stripe-js"

export const stripe = await loadStripe(PUBLIC_STRIPE_API_KEY)
